export default "__VITE_ASSET__j$ssB7js__"